var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload-cloud",
    clipPath: "url(#clip0_6231_37758)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.8333 13.3332L10.5 9.9999M10.5 9.9999L7.16663 13.3332M10.5 9.9999V17.4999M17.4916 15.3249C18.3044 14.8818 18.9465 14.1806 19.3165 13.3321C19.6866 12.4835 19.7635 11.5359 19.5351 10.6388C19.3068 9.7417 18.7862 8.94616 18.0555 8.37778C17.3248 7.80939 16.4257 7.50052 15.5 7.4999H14.45C14.1977 6.52427 13.7276 5.61852 13.0749 4.85073C12.4222 4.08295 11.604 3.47311 10.6817 3.06708C9.75943 2.66104 8.75709 2.46937 7.75006 2.50647C6.74304 2.54358 5.75752 2.80849 4.86761 3.28129C3.97771 3.7541 3.20656 4.42249 2.61215 5.23622C2.01774 6.04996 1.61554 6.98785 1.43578 7.9794C1.25602 8.97095 1.30339 9.99035 1.57431 10.961C1.84523 11.9316 2.33267 12.8281 2.99997 13.5832",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6231_37758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.b28b7acc61949cb00b2c8fe5a440b375.svg";
export { ForwardRef as ReactComponent };